import { FunctionComponent } from "react";
import neatMission from '../../../../assets/neatt-mission.png';
import { ReactComponent as RightArrow } from '../../../../assets/landing-arrow-right.svg';
import { Link } from "react-router-dom";
import { ASSESSMENT_ITEMS } from "./data";
import AssessmentAccordion from "./AssessmentAccordian";
import AssessmentList from "./AssessmentList";


const MissionObjectives: FunctionComponent = () => {
    // TOGGLE: Change this to false to revert to regular list
    const USE_ACCORDION = true;


    return (
        <div className="my-12 px-8 flex flex-col lg:flex-row-reverse items-center justify-between">
            <div className="lg:w-[45%] lg:ml-[20px] mb-6 lg:mb-0">
                <img
                    src={neatMission}
                    height={500}
                    width={610}
                    alt="NEATT Mission"
                    className="w-full h-auto"
                />
            </div>
       
            <div className="px-6 lg:px-0 lg:w-[55%]">
                <h3 className="text-center w-full lg:text-left lg:w-fit text-3xl lg:text-2xl tracking-wider font-sans font-medium lg:border-b-2 lg:border-secondary pb-2 mb-6 lg:mt-0">
                    Our Initial Intake and Assessment Includes:  
                </h3>
               
                {USE_ACCORDION ? (
                    <AssessmentAccordion items={ASSESSMENT_ITEMS} />
                ) : (
                    <AssessmentList items={ASSESSMENT_ITEMS} />
                )}


                <Link to='/auth/client-registration' className="flex items-center mt-6">
                    <p className="text-secondary pl-6">
                        Click to Register and Schedule your Appointment
                    </p>


                    <RightArrow height={20} width={30} className="mt-0.5 ml-4" />
                </Link>
            </div>
        </div>
    );
};


export default MissionObjectives;


